import React from 'react';

import ListAltIcon from '@material-ui/icons/ListAlt';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

import {
  PERMISSAO_TELA_MEIO_PAGAMENTO_LISTAR,
  PERMISSAO_TELA_UNIDADES_LISTAR,
  PERMISSAO_TELA_CARGOS_SISTEMA_LISTAR,
  PERMISSAO_TELA_USUARIOS_LISTAR,
  PERMISSAO_TELA_PERGUNTAS_LISTAR,
  PERMISSAO_TELA_CATEGORIA_PERGUNTA_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_CAIXAS_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_PROBLEMAS_LISTAR,
  PERMISSAO_TELA_CONFIGURACOES_LISTAR,
  PERMISSAO_TELA_VIDEOS_TUTORIAIS_FC_LISTAR,
  PERMISSAO_TELA_ESTADOS_BRASILEIROS_LISTAR,
  PERMISSAO_TELA_LOJAS_LISTAR,
  PERMISSAO_TELA_TABELA_IBPT_LISTAR,
  PERMISSAO_TELA_NCMS_LISTAR,
  PERMISSAO_TELA_TABELA_CST_IBSCBS_LISTAR,
  PERMISSAO_TELA_TABELA_CCLASSTRIB_LISTAR,
  PERMISSAO_TELA_PERFIS,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';
import StyledMenuItemLink from './StyledMenuItemLink';

const SubMenuSistema = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Sistema"
    icon={<MoreHorizIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_MEIO_PAGAMENTO_LISTAR] &&
      hasResource('tipospagamento')}
    {permissoes[PERMISSAO_TELA_UNIDADES_LISTAR] && hasResource('unidades')}
    {permissoes[PERMISSAO_TELA_CARGOS_SISTEMA_LISTAR] && hasResource('cargos')}
    {permissoes[PERMISSAO_TELA_USUARIOS_LISTAR] && hasResource('users')}
    {permissoes[PERMISSAO_TELA_PERGUNTAS_LISTAR] && hasResource('perguntas')}
    {permissoes[PERMISSAO_TELA_CATEGORIA_PERGUNTA_LISTAR] &&
      hasResource('categorias_perguntas')}
    {permissoes[PERMISSAO_TELA_CATEGORIAS_CAIXAS_LISTAR] &&
      hasResource('categorias_frente_caixas')}
    {permissoes[PERMISSAO_TELA_CATEGORIAS_PROBLEMAS_LISTAR] &&
      hasResource('categorias-problemas-despesas')}
    {permissoes[PERMISSAO_TELA_CONFIGURACOES_LISTAR] && (
      <StyledMenuItemLink
        key="config_correto"
        to="/config_correto"
        primaryText="Configurações"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_VIDEOS_TUTORIAIS_FC_LISTAR] &&
      hasResource('videos_tutoriais_fc')}
    {permissoes[PERMISSAO_TELA_ESTADOS_BRASILEIROS_LISTAR] &&
      hasResource('estados')}
    {permissoes[PERMISSAO_TELA_LOJAS_LISTAR] && hasResource('empresa-loja')}
    {permissoes[PERMISSAO_TELA_TABELA_IBPT_LISTAR] &&
      hasResource('tabela-ibtp')}
    {permissoes[PERMISSAO_TELA_NCMS_LISTAR] && hasResource('ncm-items')}
    {permissoes[PERMISSAO_TELA_TABELA_CST_IBSCBS_LISTAR] &&
      hasResource('tabela-cst-ibs-cbs')}
    {permissoes[PERMISSAO_TELA_TABELA_CCLASSTRIB_LISTAR] &&
      hasResource('tabela-c-class-trib')}
    {permissoes[PERMISSAO_TELA_PERFIS] && hasResource('perfils')}
  </SubMenu>
);

export default SubMenuSistema;
